import React from 'react';
import './Skills.css';

// Languages
import JavaScript from '../../assets/javascript.png';
import TypeScript from '../../assets/typescript.png';
import Python from '../../assets/python.png';
import Swift from '../../assets/swift.png';
import Java from '../../assets/java.png';
import HTML from '../../assets/html.png';
import CSS from '../../assets/css.png';

// Frameworks
import Django from '../../assets/django.png';
import NextJS from '../../assets/nextjs.png';
import React_icon from '../../assets/react.png';
import SwiftUI from '../../assets/swiftui.png';
import NodeJS from '../../assets/nodejs.png';
import Vue from '../../assets/vue.png';
import FastAPI from '../../assets/fastapi.png';

// Databases
import PostgreSQL from '../../assets/postgres.webp';
import MongoDB from '../../assets/mongodb.webp';
import MySQL from '../../assets/mysql.png';
import Redis from '../../assets/redis.png';

// Tools & Platforms
import Firebase from '../../assets/firebase.png';
import Docker from '../../assets/docker.webp';
import Azure from '../../assets/azure.png';
import GitHub from '../../assets/github.png';
import Postman from '../../assets/postman.png';
import VSCode from '../../assets/vscode.png';
import Xcode from '../../assets/xcode.png';
import Cloudflare from '../../assets/cloudflare.png';

const Skills = () => {
    const skillCategories = [
        {
            title: "Languages",
            skills: [
                { name: "JavaScript", icon: JavaScript },
                { name: "TypeScript", icon: TypeScript },
                { name: "Python", icon: Python },
                { name: "Swift", icon: Swift },
                { name: "Java", icon: Java },
                { name: "HTML", icon: HTML },
                { name: "CSS", icon: CSS },
            ]
        },
        {
            title: "Frameworks",
            skills: [
                { name: "Django", icon: Django },
                { name: "NextJS", icon: NextJS },
                { name: "React", icon: React_icon },
                { name: "SwiftUI", icon: SwiftUI },
                { name: "NodeJS", icon: NodeJS },
                { name: "Vue", icon: Vue },
                { name: "FastAPI", icon: FastAPI },
            ]
        },
        {
            title: "Databases",
            skills: [
                { name: "PostgreSQL", icon: PostgreSQL },
                { name: "MongoDB", icon: MongoDB },
                { name: "MySQL", icon: MySQL },
                { name: "Redis", icon: Redis },
            ]
        },
        {
            title: "Tools & Platforms",
            skills: [
                { name: "Firebase", icon: Firebase },
                { name: "Docker", icon: Docker },
                { name: "Azure", icon: Azure },
                { name: "GitHub", icon: GitHub },
                { name: "Postman", icon: Postman },
                { name: "VS Code", icon: VSCode },
                { name: "Xcode", icon: Xcode },
                { name: "Cloudflare", icon: Cloudflare },
            ]
        }
    ];

    return (
        <section className="skills container section" id="skills">
            <h2 className="section__title">Skills</h2>

            <div className="skills__container">
                {skillCategories.map((category, categoryIndex) => (
                    <div key={categoryIndex} className="skills__category">
                        <h3 className="skills__category-title">{category.title}</h3>
                        <div className="skills__grid">
                            {category.skills.map((skill, skillIndex) => (
                                <div key={skillIndex} className="skills__item">
                                    <div className="skills__item-icon">
                                        <img src={skill.icon} alt={skill.name} />
                                    </div>
                                    <h3 className="skills__item-title">{skill.name}</h3>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Skills; 